<template>
    <div>
        <div class="flex items-center">
            <img loading="lazy" v-if="promotionImage && showImage" class="w-10 h-10 object-cover" :src="`/storage/${promotionImage}`">
            <p class="ml-4  pr-2">{{ promotionDescription }}</p>
        </div>
        <div>
            <span>{{ promotionInfo === 0 ? trans.get('wizard.free') : promotionInfo }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        promotionImage: {
            type: String,
            default: null
        },
        promotionDescription: {
            type: String,
            required: true
        },
        promotionInfo: {
            type: String,
            required: true
        },
        showImage: {
            type: Boolean,
            default: false
        },
    }
}
</script>
